import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getUrl } from 'utils';
import { LocalizationLinkedList, ExcludeSettingsForm, Loader } from 'components';
import { advancedLocalizationPages } from 'constants';
import { routes } from 'config';
import { selectUserRoleIsPublisher } from 'store/selectors';
import { manageAppsAPI } from 'services/manageApps.service';
import * as S from './AdvancedExcludeSettingsPage.styled';

// const publishers = [
//   {
//     pb_number: 194699,
//     pb_name: '\thardcoded data',
//   },
//   {
//     pb_number: 194700,
//     pb_name: '\thardcoded data2',
//   },
//   {
//     pb_number: 194701,
//     pb_name: '\thardcoded data3',
//   },
// ];

const pba_id = 'c490cd1d-72a5-40ad-9899-b42b3fe4cc33';

const AdvancedExcludeSettingsPage = () => {
  const pages = useMemo(
    () =>
      advancedLocalizationPages.map((page) => {
        return { ...page, link: getUrl(routes, page.url_id) };
      }),
    [],
  );
  const isAdvertiser = useSelector((state) => state.auth.pb_roles).includes('advertiser');
  const userRole = useSelector(selectUserRoleIsPublisher);
  const { isLoading, data } = manageAppsAPI.useFetchAppAdvancedDataQuery({ pba_id, isAdvertiser });

  // let newData = data ? { ...data, excluded_publishers: [...publishers] } : undefined;

  const [fetchSaveOptOut, result] = manageAppsAPI.useFetchSaveOptOutMutation();
  return (
    <>
      <S.Container>
        {isLoading && <Loader.Global />}
        <h1>Advanced Settings (Local Data)</h1>
        <S.Main>
          <S.Wrap>
            <S.ListPosition>
              <LocalizationLinkedList data={pages} show={userRole} />
            </S.ListPosition>
            <ExcludeSettingsForm data={data} updateAction={fetchSaveOptOut} result={result} />
          </S.Wrap>
        </S.Main>
      </S.Container>
    </>
  );
};

export default AdvancedExcludeSettingsPage;
